// const API_BASE_URL = "https://backend-api.madame-sereine.com/";
// const API_BASE_URL = "http://[IP_ADDRESS]"; //dev enviroment ip
const API_BASE_URL = "https://dev-apis.madame-sereine.com/"; //dev enviroment url


const getApiUrl = (endpoint: string) => API_BASE_URL + endpoint;

// Auth
export const LOGIN = getApiUrl("Admin/Login");
export const LOGOUT = getApiUrl("Admin/logout");

// Categories
export const LIST_CATEGORIES = getApiUrl("Admin/list_categories");
export const ADD_EDIT_DELETE_CATEGORY = getApiUrl(
  "Admin/add_edit_delete_category",
);

// Programs
export const LIST_PROGRAM = getApiUrl("Admin/list_program");
export const LIST_PROGRAM_DETAILS = getApiUrl("Admin/list_program_days");

export const ADD_EDIT_PROGRAMS_DAYS = getApiUrl(
  "Admin/add_edit_program_day_image",
);

export const ADD_EDIT_PROGRAMS = getApiUrl("Admin/add_edit_programs");
export const SEND_PROGRAM_NOTIFICATION = getApiUrl(
  "Admin/send_program_notification",
);
export const GET_APPLE_PRODUCT_PRICE = getApiUrl(
  "Admin/get_apple_product_price",
);
// podcasts
export const LIST_PODCAST = getApiUrl("Admin/list_podcasts");
export const LIST_PODCAST_DETAILS = getApiUrl("Admin/list_podcast_days");
export const ADD_EDIT_PODCASTS = getApiUrl("Admin/add_edit_podcast");

// Meditation Guides
export const LIST_MEDITATION_GUIDES = getApiUrl("Admin/list_meditation_guides");
export const ADD_EDIT_MEDITATION_GUIDES = getApiUrl(
  "Admin/add_edit_meditation_guides",
);
// Magazines
export const LIST_MAGAZINES = getApiUrl("Admin/list_magazines");
export const ADD_EDIT_MAGAZINES = getApiUrl("Admin/add_edit_magazines");

// Questions
export const LIST_QUESTIONS = getApiUrl("Admin/list_questions");
export const ADD_EDIT_QUESTIONS = getApiUrl("Admin/add_edit_questions");
export const DELETE_QUESTION = getApiUrl("Admin/delete_question");

// Activities
export const LIST_ACTIVITIES = getApiUrl("Admin/list_program_activity");
export const ADD_EDIT_ACTIVITIES = getApiUrl("Admin/add_edit_program_activity");
// Terms & Policies
export const LIST_TERMS = getApiUrl("Admin/list_terms");
export const ADD_EDIT_TERMS = getApiUrl("Admin/add_edit_terms");

export const LIST_POLICY = getApiUrl("Admin/list_policy");
export const ADD_EDIT_POLICY = getApiUrl("Admin/add_edit_policy");

// Users
export const LIST_USERS = getApiUrl("Admin/list_users");
export const DELETE_BLOCK_USER = getApiUrl("Admin/delete_block_users");
export const LIST_USER_DETAILS = getApiUrl("Admin/list_user_details");

// Banners
export const LIST_BANNERS = getApiUrl("Admin/list_banners");
export const ADD_EDIT_BANNERS = getApiUrl("Admin/add_edit_banner");
// Srories
export const LIST_STORY = getApiUrl("Admin/list_hot_stories");
export const ADD_EDIT_STORY = getApiUrl("Admin/add_edit_hot_stories");
// Image upload
export const IMAGE_UPLOAD = getApiUrl("Admin/image_upload");
export const ADD_EDIT_ABOUT_US = getApiUrl("Admin/add_edit_about_us");
export const LIST_ABOUT_US = getApiUrl("Admin/list_about_us");
export const LIST_UPPORT_CONTACT = getApiUrl("Admin/list_support_contact");
export const ADD_EDIT_PROMO_CODE = getApiUrl("Admin/add_edit_promo_code");
export const DELETE_PROMO_CODE = getApiUrl("Admin/add_edit_promo_code");
export const LIST_PROMO_CODES = getApiUrl("Admin/list_promo_codes");

// Analytics / Dashboard
export const GET_ANALYTICS = getApiUrl("Admin/analytics");
export const LIST_ANALYTICS_USER = getApiUrl("Admin/list_analytics_user");
export const GET_PROMO_CODE_ANALYTICS = getApiUrl("Admin/promo_code_analytics");
export const LIST_PROMO_REDEMPTIONS = getApiUrl("Admin/list_promo_redemptions");
export const LIST_TRANSACTIONS = getApiUrl("Admin/list_transactions");

// Version Control
export const GET_VERSION_CONTROL = getApiUrl("Admin/list_versions");
export const ADD_EDIT_VERSION_CONTROL = getApiUrl("Admin/add_update_versions");

// Push Campaign
export const LIST_TAGS = getApiUrl("Admin/list_tags");
export const LIST_CAMPAIGN_USERS = getApiUrl("Admin/list_campaign_users");
export const GET_USERS_COUNT = getApiUrl("Admin/get_users_count");
export const PUSH_CAMPAIGN_SCHEDULER = getApiUrl("Admin/push_campaign_scheduler");
export const LIST_PUSH_CAMPAIGNS = getApiUrl("Admin/list_push_campaigns");
export const EDIT_PUSH_CAMPAIGN = getApiUrl("Admin/edit_push_campaign");
